// CallToAction.js
// -----------------------------------------------------------------------------
// Primary "Plan a Visit" call-to-action for NHV. Thin, token-based wrapper around
// the design-system <PrimaryButton>. Kept as a standalone export so existing call
// sites (Home hero, etc.) continue to work, while inheriting consistent styling,
// safe navigation, and accessible focus handling from the primitive.
//
// Props:
//   - label      : node     (default 'Plan a Visit')  button text
//   - to         : string   (default '/join')         internal route target
//   - variant    : 'solid'|'soft'|'outlined'|'plain'  (default 'solid')
//   - color      : 'primary'|'accent'|'neutral'       (default 'accent', matching
//                  the orange "Plan a Visit" in the nav bar)
//   - size       : 'sm'|'md'|'lg'                      (default 'lg')
//   - fullWidth  : boolean  (default false)
//   - sx         : object   (default {})               extra Joy sx overrides
// -----------------------------------------------------------------------------

import * as React from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton } from './ui';

import './styles/CallToAction.css';

const CallToAction = ({
  label = 'Plan a Visit',
  to = '/join',
  variant = 'solid',
  color = 'accent',
  size = 'lg',
  fullWidth = false,
  sx = {},
}) => {
  // Zero-trust: only accept a non-empty string route; otherwise fall back to the
  // safe default so the button never links to an undefined/empty destination.
  const safeTo = typeof to === 'string' && to.length > 0 ? to : '/join';
  const safeLabel =
    label === undefined || label === null || label === '' ? 'Plan a Visit' : label;

  return (
    <PrimaryButton
      to={safeTo}
      variant={variant}
      color={color}
      size={size}
      fullWidth={fullWidth}
      sx={sx}
    >
      {safeLabel}
    </PrimaryButton>
  );
};

CallToAction.propTypes = {
  label: PropTypes.node,
  to: PropTypes.string,
  variant: PropTypes.oneOf(['solid', 'soft', 'outlined', 'plain']),
  color: PropTypes.oneOf(['primary', 'accent', 'neutral']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  fullWidth: PropTypes.bool,
  sx: PropTypes.object,
};

export default CallToAction;
